{
  "common": {
    "title": "Akademie",
    "dateFormat": "dd.MM.yyyy",
    "dateTimeFormat": "dd.MM.yyyy HH:mm",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen",
    "open": "Öffnen",
    "success": "Erfolgreich",
    "failure": "Fehlgeschlagen"
  },
  "navigation": {
    "footer": {
      "contact": "Kontakt"
    },
    "navbar": {
      "welcome": "Willkommen, {{ fullName }}"
    },
    "menu": {
      "dashboard": "Dashboard",
      "courses": "Schulungen",
      "instructions": "Unterweisungen",
      "information": "Informationen",
      "settings": "Einstellungen"
    }
  },
  "authentication": {
    "login": {
      "login": "Einloggen",
      "error": "Falsche Zugangsdaten",
      "forgot-password": "Passwort vergessen?"
    },
    "logout": {
      "logout": "Ausloggen"
    },
    "forgot-password": {
      "forgot-password": "Passwort vergessen",
      "email": "Email",
      "forgot-password-hint": "Wir senden dir einen Link zurm Rücksetzen deines Passworts per E-Mail zu.",
      "reset-password": "Passwort zurücksetzen",
      "required": "Du musst deine E-Mail Adresse angeben",
      "failure": "Fehler, bitte versuche es später nochmals."
    },
    "reset-password-hint": {
      "hint": "Bitte prüfe deine E-Mails und befolge die Anleitung für das Zurücksetzen deines Passworts.\n\nPrüfe deine E-Mail Adresse falls du keine E-Mail erhalten hast.\n\nFalls du keine E-Mail erhalten hast, wende dich bitte an: \nvanessa.wiesinger@sar-anlagenbau.at",
      "back": "Zurück"
    }
  },
  "instruction": {
    "instruction-page": {
      "title": "Offene Unterweisungen"
    },
    "my-instructions": {
      "title": "Offene Unterweisungen"
    },
    "my-confirmed-instructions": {
      "title": "Bestätigte Unterweisungen"
    },
    "instruction-list": {
      "open": "Öffnen"
    },
    "chapter-detail": {
      "confirm": "Bestätigen",
      "confirmation-dialog": {
        "content": "Ich bestätige, dass ich das Kapitel gelesen und verstanden habe.",
        "title": "Kapitel bestätigen"
      },
      "download": "Herunterladen"
    },
    "instruction-detail": {
      "confirmed": "Bestätigt am: ",
      "created": "Erstellt am: ",
      "deadline": "Deadline: "
    },
    "instruction-item": {
      "since": "Verfügbar seit: ",
      "confirmed": "Bestätigt am: ",
      "deadline": "Deadline: "
    }
  },
  "instruction-details": {
    "quizz-question": {
      "one-or-more-hint": "* Wähle eine oder mehr Antwortmöglichkeiten aus."
    },
    "chapter-quizz": {
      "check-answers": "Antworten prüfen",
      "success": "Kapitel bestätigt!",
      "error": "Deine Antworten waren leider falsch! - versuche es noch einmal"
    },
    "chapters": {
      "confirmed": "Kapitel bestätigt",
      "not-confirmed": " Kapitel noch nicht bestätigt",
      "open-chapter": "Kapitel öffnen",
      "confirm-chapter": "Kapitel bestätigen",
      "confirmed-percentage": "{{ percentage }}% abgeschlossen",
      "confirmed-chapters": "Bestätigt {{ confirmedChapters }}/{{chapters}}"
    }
  },
  "dashboard": {
    "dashboard": {
      "active-courses": "Aktive Schulungen",
      "finished-courses": "Abgeschlossene Schulungen",
      "open-instructions": "Offene Unterweisungen",
      "finished-instructions": "Abgeschlossene Unterweisungen",
      "progress": "Gesamtfortschritt",
      "information": "Ungelesene Informationen"
    }
  },
  "settings": {
    "change-password": {
      "title": "Passwort ändern",
      "min-length": "Das Passwort ist zu kurz",
      "required": "Erforderliche Eingabe",
      "old-password": "Aktuelles Passwort",
      "new-password": "Neues Passwort",
      "new-password-check": "Neues Passwort bestätigen",
      "password-mismatch": "Die Passwörter stimmen nicht überein",
      "password-complexity": {
        "error": "Das Passwort muss die folgenden Bedingungen erfüllen:",
        "length": "- {{ length }} Zeichen Länge",
        "required-capital-letters": "- {{ requiredCapitalLetters }} Großbuchstaben",
        "required-small-letters": "- {{ requiredSmallLetters }} Kleinbuchstaben",
        "required-numbers": "- {{ requiredNumbers }} Ziffern",
        "required-symbols": "- {{ requiredSymbols }} Symbole"
      },
      "failure": "Fehler: Passwort konnte nicht gesetzt werden.",
      "success": "Passwort wurde geändert",
      "logout-hint": "Durch das Ändern des Passworts wirst du ausgeloggt und du musst dich neu einloggen."
    },
    "change-language": {
      "title": "Sprache",
      "change-language": "Sprache auswählen"
    }
  }
}
